import { Smartphone, Download } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export const AppSection = () => {
  const { t } = useLanguage();

  return (
    <section className="section-spacing bg-[#111111]" data-testid="app-section">
      <div className="section-container">
        <div className="glass-card rounded-3xl p-8 lg:p-16 relative overflow-hidden">
          {/* Background Glow */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-yellow-500/10 rounded-full blur-3xl" />
          
          <div className="relative z-10 grid lg:grid-cols-2 gap-12 items-center">
            {/* Content */}
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-yellow-500/10 border border-yellow-500/20 mb-6">
                <Smartphone className="w-4 h-4 text-yellow-500" />
                <span className="text-yellow-500 text-sm font-medium">{t.app.badge}</span>
              </div>
              
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
                {t.app.title}
              </h2>
              
              <p className="text-neutral-300 text-lg mb-8 leading-relaxed">
                {t.app.description}
              </p>

              {/* App Store Links */}
              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="https://apps.apple.com/se/app/taxi-nora/id6741321616"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="app-btn"
                  data-testid="app-store-btn"
                >
                  <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                  </svg>
                  <div className="text-left">
                    <span className="text-xs text-neutral-400 block">{t.app.downloadOn}</span>
                    <span className="font-semibold">{t.app.appStore}</span>
                  </div>
                </a>
                
                <a
                  href="https://play.google.com/store/apps/details?id=com.taxicaller.TaxiNora.app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="app-btn"
                  data-testid="play-store-btn"
                >
                  <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                  </svg>
                  <div className="text-left">
                    <span className="text-xs text-neutral-400 block">{t.app.getItOn}</span>
                    <span className="font-semibold">{t.app.googlePlay}</span>
                  </div>
                </a>
              </div>
            </div>

            {/* Phone Mockup */}
            <div className="hidden lg:flex justify-center">
              <div className="relative">
                <div className="w-64 h-[500px] bg-neutral-900 rounded-[3rem] border-4 border-neutral-800 shadow-2xl flex items-center justify-center">
                  <div className="text-center p-8">
                    <h4 className="text-white font-bold text-xl mb-2">Taxi Kalmar</h4>
                    <p className="text-neutral-400 text-sm">{t.app.bookYourRide}</p>
                    <div className="mt-8 flex items-center justify-center gap-2 text-yellow-500">
                      <Download className="w-5 h-5" />
                      <span className="font-medium">{t.app.download}</span>
                    </div>
                  </div>
                </div>
                {/* Glow effect */}
                <div className="absolute -inset-4 bg-yellow-500/20 rounded-[3.5rem] blur-xl -z-10" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
